export const enum CheckboxValue {
  True = 'true',
  False = 'false',
}

export const enum CheckboxAnalyticsValue {
  Select = 'Select',
  Deselect = 'Deselect',
}

export const enum ButtonValue {
  Clicked = 'clicked',
  Off = 'off',
}

export const enum TitlePrefix {
  Mrs = 'mrs',
  Mr = 'mr',
  Diverse = 'diverse',
}

export const enum HTMLInputFieldType {
  Text = 'text',
  Tel = 'tel',
  Password = 'password',
}

export const enum HTMLAutoCompleteAttribute {
  Off = 'off',
  CurrentPassword = 'current-password',
  NewPassword = 'new-password',
  Username = 'username',
}

export const enum FieldChangeTrigger {
  Change = 'change',
  Blur = 'blur',
}
